export const getTpaFirmName = (tpaFirmName, tpaFirmNameUnlisted) => {
  if (
    tpaFirmName === undefined ||
    tpaFirmName.value.value === 'myFirmIsntListed'
  ) {
    return tpaFirmNameUnlisted.value;
  }
  return tpaFirmName.value.value;
};
